import PropTypes from 'prop-types'
import BaseButton from "./Button.jsx"

export default function PrimaryOutlineButton({children, ...props}) {
  return (
    <BaseButton color={" btn-outline-primary"} {...props}>
      {children}
    </BaseButton>
  )
}

PrimaryOutlineButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string,
  type: PropTypes.string
}